'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

require('./menu-link.scss');

var _menu = require('../services/menu.service');

var _menu2 = _interopRequireDefault(_menu);

var _menuLinkTpl = require('./menu-link.tpl.html');

var _menuLinkTpl2 = _interopRequireDefault(_menuLinkTpl);

var _menuToggleTpl = require('./menu-toggle.tpl.html');

var _menuToggleTpl2 = _interopRequireDefault(_menuToggleTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/* eslint-disable import/no-unresolved, import/default */

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.directives.menuLink', [_menu2.default]).directive('tbMenuLink', MenuLink).filter('nospace', NoSpace).name;

/*@ngInject*/

function MenuLink($compile, $templateCache, menu) {

    var linker = function linker(scope, element) {
        var template;

        if (scope.section.type === 'link') {
            template = $templateCache.get(_menuLinkTpl2.default);
        } else {
            template = $templateCache.get(_menuToggleTpl2.default);

            var parentNode = element[0].parentNode.parentNode.parentNode;
            if (parentNode.classList.contains('parent-list-item')) {
                var heading = parentNode.querySelector('h2');
                element[0].firstChild.setAttribute('aria-describedby', heading.id);
            }

            scope.sectionActive = function () {
                return menu.sectionActive(scope.section);
            };

            scope.sectionHeight = function () {
                return menu.sectionHeight(scope.section);
            };
        }

        element.html(template);

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            section: '='
        }
    };
}

function NoSpace() {
    return function (value) {
        return !value ? '' : value.replace(/ /g, '');
    };
}


// WEBPACK FOOTER //
// ./src/app/components/menu-link.directive.js